(function(variable_0) {
    var variable_1 = parseInt(variable_0("#map")["attr"]("data-zoom"));
    var variable_2 = variable_0("#map")["attr"]("data-latitude");
    var variable_3 = variable_0("#map")["attr"]("data-longitude");
    "use strict";
    var variable_4 = -30;
    Pace["on"]("start", function() {
        variable_0("#preloader")["show"]()
    });
    Pace["on"]("done", function() {
        variable_0("#status")["fadeOut"]();
        variable_0("#preloader")["delay"](1000)["fadeOut"]("slow");
        variable_0("body")["delay"](1000)["css"]({
            "overflow-x": "hidden"
        })["css"]({
            "overflow-y": "auto"
        });
        variable_0("body")["scrollspy"]({
            target: ".nav-menu"
        });
        variable_0("body")["data"]()["bs.scrollspy"]["options"]["offset"] = Math["abs"](variable_4) + 10;
        variable_0("body")["data"]()["bs.scrollspy"]["process"]();
        variable_0("body")["scrollspy"]("refresh");
        var variable_5 = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: "-200px",
            mobile: true,
            live: true
        });
        new WOW()["init"]();

        function variable_6(variable_7, variable_8) {
            var variable_9 = new Image();
            variable_9["onload"] = function() {
                var variable_10 = variable_9["height"];
                var variable_11 = variable_9["width"];
                variable_7["css"]("height", variable_10)
            };
            variable_9["src"] = variable_8
        }
        variable_07();
        variable_0(window)["resize"](function() {
            variable_07();
            variable_0d()
        });

        function variable_12() {
            if (variable_0(".skill-item")["length"] > 0) {
                variable_13(variable_0(".skill-item"))
            }
        }

        function variable_13(variable_7) {
            if (variable_7["hasClass"]("line")) {
                var variable_14 = 1;
                variable_7["each"](function() {
                    var variable_7 = variable_0(this);
                    var variable_00 = variable_7["attr"]("data-percent");
                    var variable_01 = variable_7["attr"]("data-percent");
                    variable_7["find"](".bar")["delay"](variable_14 * 400)["animate"]({
                        width: variable_01 + "%"
                    }, 2000, "easeInOutExpo");
                    variable_14++
                })
            };
            if (variable_7["hasClass"]("dotted")) {
                var variable_14 = 1;
                variable_7["each"](function() {
                    var variable_7 = variable_0(this);
                    var variable_11 = variable_7["find"](".skill-dots")["width"]();
                    var variable_00 = variable_7["attr"]("data-percent");
                    var variable_02 = variable_7["find"]("span")["outerWidth"](true);
                    var variable_03 = Math["ceil"](variable_11 / variable_02);
                    var variable_04 = Math["ceil"](variable_00 * variable_03 / 100);
                    variable_7["find"](".init")["remove"]();
                    for (var variable_05 = 1; variable_05 < variable_04; variable_05++) {
                        variable_7["find"](".prg")["append"]("<span class=\"filled\"></span>")
                    };
                    for (var variable_06 = 1; variable_06 < variable_03 - variable_04; variable_06++) {
                        variable_7["find"](".prg")["append"]("<span class=\"empty\"></span>")
                    };
                    variable_14++
                })
            }
        }

        function variable_07() {
            if (variable_0(window)["width"]() < 966) {
                variable_0("#nav-row nav")["prependTo"](variable_0("#top-bar"))
            } else {
                variable_0("#top-bar nav")["appendTo"](variable_0("#nav-row .container"))
            }
        }
        variable_0(".slider-thumbs")["owlCarousel"]({
            pagination: false,
            singleItem: true,
            navigation: true,
            navigationText: ["", ""],
            mouseDrag: true,
            afterInit: function() {
                variable_0(".slider-thumbs .owl-buttons")["appendTo"](variable_0(".slider-thumbs"))
            }
        });
        variable_0(".clients-slider-holder")["owlCarousel"]({
            pagination: false,
            singleItem: true,
            navigation: true,
            navigationText: ["", ""],
            mouseDrag: true,
            afterInit: function() {
                variable_0(".clients-slider-holder .owl-buttons")["appendTo"](variable_0(".clients-slider-holder"))
            }
        });

        function variable_08() {
            var variable_09 = variable_0("#portfolio-grid");
            variable_09["isotope"]({
                masonry: {
                    columnWidth: 5
                }
            });
            variable_0(".group-selectors a")["click"](function(variable_0a) {
                variable_0a["preventDefault"]();
                var variable_0b = variable_0(this)["attr"]("data-filter");
                variable_09["isotope"]({
                    filter: variable_0b
                });
                variable_0(".group-selectors a.active")["removeClass"]("active");
                variable_0(this)["toggleClass"]("active");
                return false
            })
        }
        if (variable_0(".bg-image[data-bg-image]")["length"] > 0) {
            variable_0(".bg-image[data-bg-image]")["each"](function() {
                var variable_7 = variable_0(this);
                var variable_0c = variable_6(variable_7, variable_7["attr"]("data-bg-image"));
                variable_7["css"]("background-position", "center")["css"]("background-image", "url('" + variable_7["attr"]("data-bg-image") + "')")["css"]("background-size", "cover")["css"]("background-repeat", "no-repeat")
            })
        };
        if (variable_0(".bg-color[data-bg-color]")["length"] > 0) {
            variable_0(".bg-color[data-bg-color]")["each"](function() {
                var variable_7 = variable_0(this);
                variable_7["css"]("background-color", variable_7["attr"]("data-bg-color"))
            })
        };

        function variable_0d() {
            variable_0(".eq-dimensions")["each"](function() {
                var variable_0e = variable_0(this)["height"]();
                var variable_01 = variable_0(this)["width"]();
                var variable_0f = Math["max"](variable_0e, variable_01);
                variable_0(this)["width"](variable_0f)["height"](variable_0f)
            })
        }
        variable_0d();

        function variable_10() {
            if (variable_0(".map-holder")["length"] > 0) {
                var variable_11 = [{
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "visibility": "simplified"
                    }, {
                        "\x63\x6F\x6C\x6F\x72": "#E6E6E6"
                    }]
                }, {
                    "featureType": "administrative",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "visibility": "on"
                    }, {
                        "saturation": -100
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "\x63\x6F\x6C\x6F\x72": "#808080"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "water",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "\x63\x6F\x6C\x6F\x72": "#CECECE"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "poi",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "\x63\x6F\x6C\x6F\x72": "#E5E5E5"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "\x73\x74\x79\x6C\x65\x72\x73": [{
                        "\x63\x6F\x6C\x6F\x72": "#ffffff"
                    }, {
                        "visibility": "on"
                    }]
                }, {}];
                var variable_12 = (variable_2);
                var variable_13 = (variable_3);
                var variable_14 = {
                    mapTypeControlOptions: {
                        mapTypeIds: ["Styled"]
                    },
                    center: new google["maps"].LatLng(variable_12, variable_13),
                    zoom: variable_1,
                    disableDefaultUI: true,
                    scrollwheel: false,
                    mapTypeId: "Styled"
                };
                var variable_15 = document["getElementById"]("map");
                var variable_16 = new google["maps"].Map(variable_15, variable_14);
                var variable_17 = new google["maps"].StyledMapType(variable_11, {
                    name: "Styled"
                });
                var variable_18 = new google["maps"].Marker({
                    position: new google["maps"].LatLng(variable_2, variable_3),
                    map: variable_16
                });
                variable_16["mapTypes"]["set"]("Styled", variable_17)
            }
        }
        variable_0("[data-placeholder]")["focus"](function() {
            var variable_19 = variable_0(this);
            if (variable_19["val"]() == variable_19["attr"]("data-placeholder")) {
                variable_19["val"]("")
            }
        })["blur"](function() {
            var variable_19 = variable_0(this);
            if (variable_19["val"]() == "" || variable_19["val"]() == variable_19["attr"]("data-placeholder")) {
                variable_19["addClass"]("placeholder");
                variable_19["val"](variable_19["attr"]("data-placeholder"))
            }
        })["blur"]();
        variable_0("[data-placeholder]")["parents"]("form")["submit"](function() {
            variable_0(this)["find"]("[data-placeholder]")["each"](function() {
                var variable_19 = variable_0(this);
                if (variable_19["val"]() == variable_19["attr"]("data-placeholder")) {
                    variable_19["val"]("")
                }
            })
        });
        var variable_1a = document["getElementById"]("cn-button"),
            variable_1b = document["getElementById"]("cn-wrapper"),
            variable_1c = document["getElementById"]("cn-overlay");
        var variable_1d = false;
        variable_1a["addEventListener"]("click", variable_1f, false);
        variable_1b["addEventListener"]("click", variable_1e, false);

        function variable_1e(variable_0a) {
            variable_0a["stopPropagation"]()
        }

        function variable_1f(variable_0a) {
            if (!variable_0a) {
                var variable_0a = window["event"]
            };
            variable_0a["stopPropagation"]();
            if (!variable_1d) {
                variable_20()
            } else {
                variable_21()
            }
        }

        function variable_20() {
            variable_1d = true;
            variable_1a["innerHTML"] = "-";
            classie["add"](variable_1c, "on-overlay");
            classie["add"](variable_1b, "opened-nav")
        }

        function variable_21() {
            variable_1d = false;
            variable_1a["innerHTML"] = "+";
            classie["remove"](variable_1c, "on-overlay");
            classie["remove"](variable_1b, "opened-nav")
        }
        document["addEventListener"]("click", variable_21);
        variable_0(".submit")["click"](function(variable_0a) {
            variable_0a["preventDefault"]();
            variable_0(this)["parents"]("form")["submit"]()
        });

        function variable_22() {
            if (variable_0(".contact-form")["length"] > 0) {
                var variable_23 = variable_0(".contact-form")["validate"]();
                variable_0(".contact-form")["submit"](function(variable_0a) {
                    variable_0a["preventDefault"]();
                    if (variable_23["errorList"]["length"] === 0) {
                        variable_0(".contact-form .submit")["fadeOut"](function() {
                            variable_0("#loading")["css"]("visibility", "visible");
                            variable_0["post"]("submit.php", variable_0(".contact-form")["serialize"](), function(variable_24) {
                                variable_0(".contact-form input,.contact-form textarea")["not"](".submit")["val"]("");
                                variable_0(".message-box")["html"](variable_24);
                                variable_0("#loading")["css"]("visibility", "hidden");
                                variable_0(".contact-form")["css"]("display", "none")
                            })
                        })
                    }
                })
            }
        }
        var variable_25 = false;
        var variable_26 = false;
        var variable_27 = false;
        var variable_30 = false;
        variable_0("#sticked-nav a")["click"](function() {
            variable_21()
        });
        variable_0("#sticked-nav a,.nav-link,.nav-link-holder a,.close-btn, #copyright-bar a")["click"](function() {
            var variable_7 = variable_0(this);
            var variable_28 = variable_7["attr"]("href");
            if (variable_28 !== "#home") {
                variable_0("#sticked-nav")["removeClass"]("invisible")
            } else {
                variable_0("#sticked-nav")["addClass"]("invisible")
            };
            switch (variable_28) {
                case "#contact":
                    if (!variable_25) {
                        variable_25 = true;
                        setTimeout(variable_10, 500)
                    };
                    break;
                case "#portfolio":
                    if (!variable_26) {
                        variable_26 = true;
                        setTimeout(variable_08, 500)
                    };
                    break;
                case "#about":
                    if (!variable_27) {
                        variable_27 = true;
                        setTimeout(variable_12, 500)
                    };
                    break;
                case "#admin":
                    if (!variable_30) {
                       variable_30 = true;
                       setTimeout(variable_0,500)          
                    };
                    break;
            };
            variable_0(".page.active")["stop"]()["fadeOut"](function() {
                variable_0(".page.active")["removeClass"]("active");
                variable_0(variable_28)["stop"]()["fadeIn"](function() {
                    variable_0(variable_28)["addClass"]("active")
                })
            })
        });
        variable_22()
    });
    variable_0(".goto-top")["click"](function(variable_0a) {
        variable_0a["preventDefault"]();
        variable_0("html,body")["animate"]({
            scrollTop: 0
        }, 2000)
    });
    if (variable_0("a[data-rel=\"prettyphoto\"]")["length"] > 0) {
        variable_0("a[data-rel=\"prettyphoto\"]")["prettyPhoto"]()
    };
    if (variable_0("a[data-rel=\"prettyPhoto\"]")["length"] > 0) {
        variable_0("a[data-rel=\"prettyPhoto\"]")["prettyPhoto"]()
    };
    if (!window["requestAnimationFrame"]) {
        window["requestAnimationFrame"] = (function() {
            return window["webkitRequestAnimationFrame"] || window["mozRequestAnimationFrame"] || window["oRequestAnimationFrame"] || window["msRequestAnimationFrame"] || function(variable_29) {}
        })()
    }
})(jQuery)